import React, {useEffect, useState} from "react";
import {AdminGenRouteUrls, AdminModules, AdminReqUrls, AppName} from "../config/AdminConfig";
import {Flexbox, Label, MsgBox} from "../../common/fusion-ui";
import {useTheme} from "../../common/ProjectThemeProvider";
import {sendAdminRequest} from "../utils/AdminUtils";
import {
    addClass,
    checkNullStr,
    createTimeout,
    focusFormIdElement,
    getJsonValue,
    getElement,
    isBoolTrue,
    isJsonValueTrue,
    setTabTitle
} from "../../common/fusion-ui/utils/ReactUtils";
import {CssVariant} from "../../common/fusion-ui/config/FusionConfig";
import {Link, useNavigate} from "react-router-dom";
import {BaseReqUrl} from "../../common/CommonConfig";
import {ThemedButton, ThemedInput,} from "../../common/components";
import {printError, printLog} from "../../common/CommonUtils";
import {AuthPageLayout} from "../components";
import {useInternetStatus} from "../../common/fusion-ui/hook";

const ForgotPwPage = React.memo(() => {
    const TAG = 'ForgotPwPage';

    const navigate = useNavigate();
    const theme = useTheme();
    const {isOnline} = useInternetStatus();

    const FOCUS_DELAY = 2000;
    const INPUT_H = '46px';

    const Fields = {
        username: 'username',
        usernameMsg: 'usernameMsg',

        submitAsLoading: 'submitAsLoading',
        submitDisable: 'submitDisable',
        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',
    };
    const [fieldsData, setFieldsData] = useState({});

    useEffect(() => {
        setTabTitle(AdminModules.ForgotPw);
    }, []);

    return (<AuthPageLayout className={'py-sm-4'} px={0} py={1}>
        <div className={'m-0 row w-100 d-flex jc-center al-center px-4 auth-page'}
             style={{minHeight: '90vh'}}>
            <div className={'auth-panel-wrapper admin col-sm-10 col-md-5 col-lg-5'}>
                <div className={'px-2'}>
                    {/*top*/}
                    <div className={''}>
                        <Flexbox className={'pb-1'} justifyAt={'center'}>
                            <Label className={'m-0 p-0 my-1 fw-bold fs-xl text-nowrap text-theme'}>
                                {AppName}
                            </Label>
                        </Flexbox>

                        <Flexbox className={'mt-3x'} justifyAt={'center'}>
                            <Label className={'m-0 p-0 fw-bold fs-md-lg text-nowrap text-theme-resp'}>
                                {`${AdminModules.ForgotPw}?`}
                            </Label>
                        </Flexbox>

                        <Flexbox className={'mb-3 mt-1'} justifyAt={'center'}>
                            <Label className={'m-0 p-0 text-wrap text-theme-resp-80'}>
                                {`Enter your email your reset password`}
                            </Label>
                        </Flexbox>
                    </div>

                    {/*form*/}
                    <div className={'m-0 p-0 mt-1'}>
                        <form>
                            {/*username*/}
                            <ThemedInput
                                mainWrapperClassName={`w-100 pb-2x`}
                                className={`py-3`}
                                style={{height: INPUT_H}}
                                type={'email'}
                                id={Fields.username}
                                label={'Username'}
                                placeholder={'Enter your username'}
                                value={getField(Fields.username)}
                                required={true}
                                msg={getField(Fields.usernameMsg)}
                                onChange={(e, isValid) => {
                                    const value = e.target.value;
                                    updateField(Fields.username, value);
                                    if (checkNullStr(value)) {
                                        highlightIdField(Fields.username, false, Fields.usernameMsg, '');
                                    }
                                    panelLog('');
                                }}
                            />

                            {/*msg-box*/}
                            {(checkNullStr(getField(Fields.panelMsg)) || !isOnline) &&
                                <MsgBox color={!isOnline ? 'red' : getField(Fields.panelMsgColor, theme.text90)}>
                                    {!isOnline ? `You're offline!` : getField(Fields.panelMsg)}
                                </MsgBox>}


                            {/*submit*/}
                            <div className={'m-0 p-0 mt-2 mb-1 w-100'}>
                                <ThemedButton
                                    className={'w-100 px-2 py-2 rounded-3 fw-semi-bold'}
                                    text={isFieldTrue(Fields.submitAsLoading) ? 'Processing...' : 'Confirm Email'}
                                    height={INPUT_H}
                                    elasticActive={true}
                                    loadingWidth={'100%'}
                                    asLoading={isFieldTrue(Fields.submitAsLoading)}
                                    disabled={isFieldTrue(Fields.submitDisable) || !isOnline}
                                    onClick={handleSubmit}
                                />
                            </div>

                            {/*forgot-pw & request-access*/}
                            <Flexbox className={'w-100 mt-3 px-0'} justifyAt={'between'}>
                                <span></span>

                                {/*request-access*/}
                                <div>
                                <span className={''}>
                                    <span className={'text-nowrap cursor-default'} style={{color: theme.text80}}>
                                        Back to&nbsp;
                                    </span>
                                    <Link to={AdminGenRouteUrls.login} className={'td-none'}>
                                        <span className={'text-nowrap footer-link'}>
                                        {AdminModules.Login}
                                    </span>
                                    </Link>
                                </span>
                                </div>
                            </Flexbox>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </AuthPageLayout>);

    function handleSubmit(e) {
        const fun = 'handleSubmit:';
        log(fun, 'lastUrl:', getField(Fields.lastUrl));
        panelLog('');
        try {
            let verified = checkAllFieldsVerified();
            // verified = false;
            if (verified) {
                const serviceAvail = false;
                if (serviceAvail) {
                    updateField(Fields.submitAsLoading, true);
                    updateField(Fields.submitDisable, true);

                    const REQUEST_OPTIONS = {
                        username: getField(Fields.username),
                        loginLink: `${BaseReqUrl}${AdminGenRouteUrls.login}`,
                    };

                    sendAdminRequest({
                        reqUrl: AdminReqUrls.admin__forgotPw,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: (fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const message = getJsonValue(fetchedData, 'message');
                            const success = isJsonValueTrue(fetchedData, 'success');

                            if (success) {
                                panelLog(message);

                                createTimeout(() => {
                                    navigate(AdminGenRouteUrls.login);
                                }, 10000);
                            } else {
                                panelLogErr(message);
                                updateField(Fields.submitDisable, false);
                            }
                            updateField(Fields.submitAsLoading, false);
                        },
                        onError: (error) => {
                            panelLogErr('Request failed, please try again');
                            updateField(Fields.submitAsLoading, false);
                            updateField(Fields.submitDisable, false);
                            logErr(fun, error);
                        }
                    });
                } else {
                    panelLogErr('Service unavailable at the moment!');
                }
            }
        } catch (error) {
            panelLogErr('Request failed, please try again');
            updateField(Fields.submitAsLoading, false);
            updateField(Fields.submitDisable, false);
            logErr(fun, error);
        }
    }

    function checkAllFieldsVerified() {
        let verified = false;
        if (!checkNullStr(getField(Fields.username))) {
            updateField(Fields.usernameMsg, 'Username cannot be empty');
            focusIdField(Fields.username);
        } else {
            verified = true;
            panelLog("");
        }
        return verified;
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function focusIdField(id, onlyFocus = true) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
        highlightIdField(id, true);
    }

    function highlightIdField(id, highlight = true, msgField, msg, variant = CssVariant.danger) {
        if (checkNullStr(msgField)) updateField(msgField, msg);
        addClass(getElement(id, 'id'), variant, isBoolTrue(highlight));
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        log(...[text]);
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});

export default ForgotPwPage;
